import { SESSION_AGE } from "constants/vars";

export const parseJwt = (token) => {
  var base64Url = token.split(".")[1];
  var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  var jsonPayload = decodeURIComponent(
    atob(base64)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join(""),
  );

  return JSON.parse(jsonPayload);
};

export const isTokenExpired = (idToken) => {
  const authTime = parseJwt(idToken).auth_time;
  const now = new Date();
  const secondsSinceEpoch = Math.round(now.getTime() / 1000);
  const isExpired = secondsSinceEpoch - authTime > SESSION_AGE ? true : false;
  return isExpired;
};
